import { render, staticRenderFns } from "./StaffManageSettingsView.vue?vue&type=template&id=55633a0b&scoped=true"
import script from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
export * from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
import style0 from "./StaffManageSettingsView.vue?vue&type=style&index=0&id=55633a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55633a0b",
  null
  
)

export default component.exports